export default "__VITE_ASSET__1a46a209__"